import { render, staticRenderFns } from "./OsAppuserForm.vue?vue&type=template&id=a70a33f0&scoped=true"
import script from "./OsAppuserForm.vue?vue&type=script&lang=ts"
export * from "./OsAppuserForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70a33f0",
  null
  
)

export default component.exports